module.exports = __webpack_public_path__ + "img/barra-menu.367c391b.svg";